<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Documents" />
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#workpermitAdd">Documents</button>
                    </div> -->
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li>                          
                                        <li class="nav-item">
                                         <button class="btn btn-primary" type="button" @click="showAddModal()" ><i class="icofont icofont-plus"></i>Add Document</button>
                                        </li>
                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">All Documents:</h6>
                                        <button class="btn btn-primary text-white" v-if="reschedule.length > 0"
                                            data-bs-toggle="modal" data-original-title="test"
                                            data-bs-target="#rescheduleHere">Reschedule</button>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="basic-1">
                                                <thead>
                                                    <tr>
                                                        <!--<th></th>-->
                                                        <th>Sr.No.</th>
                                                        <th>Upload Date</th>
                                                        <th>Document Name</th>
                                                        <th>Document</th>
                                                        <th>Expiry Date</th>
                                                        <th>Delete</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in  workpermitdetails" :key="item.workpermitid" :class="isDocExpire(item.expirydate)?'expired':''">
                                                        <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                                                :value="item.id" /></td> -->
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.iddate }}</td>
                                                    
                                                        <td>{{ item.document_name }} </td>
                                                        <td>
                                                            <a :href="this.$hostname + 'writable/uploads/workpermit/' + item.documentpath"  target="_blank">
                                                                See Document
                                                                <!--<img :src="this.$hostname + 'writable/uploads/workpermit/' + item.documentpath" width="80px"/>-->
                                                            </a>
                                                              <button class="badge bg-success text-white" @click="downloadFile(this.$hostname + 'writable/uploads/workpermit/' + item.documentpath,item.document_name)"  >
                                                                Download
                                                                
                                                            </button>
                                                          </td> 
                                                        <td>{{ item.expirydate }}</td>
                                                          <td>
                                                            <button @click="deleteitem(item.id,item.workpermitid)" class="btn-primary">Delete</button>
                                                          </td>
                                                          
                                                          
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
<div class="modal" v-if="isAddModal" id="documentAdd" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Document</h5>
          <button type="button" class="close" @click="isAddModal=false"  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

            <div class="col-12 row" >


                                <div class="col-md-4 col-12 mt-2  position-relative">
                                    <label class="form-label">Document Name</label>
                                             <select class="form-select form-select-sm" id="doc_select2"  v-model="workpermit_row.documentid">
                                                    <option v-for="(item, index) in documentlist" :key="index" :value="item.id">{{ item.name }}</option>
                                                </select>
                                    </div>

                                    <div class="col-md-4 col-12 mt-2  position-relative">
                                        <label class="form-label">Expiry Date</label>
                                        <input class="form-control" type="date" v-model="workpermit_row.expirydate" :min="today_minimum_date"
                                            placeholder="Type Here..." required="">
                                    </div>



                                    <div class="col-md-4 col-12 mt-2 position-relative">
                                        <label class="form-label">Select Documents</label>
                                        <input class="form-control" type="file" @change="onFileChange(workpermit_row)"
                                            placeholder="Type Here..." required="">
                                    </div>

                  
</div>
        </div>
        <div class="modal-footer">
        
          <button type="button" class="btn btn-primary" @click="save_document">Save</button>
        </div>
      </div>
    </div>
  </div>
 <a ref="downloadLink" style="display:none;"></a>
    <!--<ModalsPart v-if="!['login'].includes($route.name)" @getGatePassData="updateData" />-->
</template>
<style scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}

.badge_sm {
    padding: 2px 5px;
    border-radius: 10px;
    font-size: smaller;
    color: white;
}
.expired{
    background: #fad7d7;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import Swal from 'sweetalert2';
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        if(this.$route.query.id){
        this.getBasics(this.$route.query.id);
        }else{
        this.getBasics();
        }
        

    }, data() {
        return {
            reschedule: [],
            user: [],
            workpermitdetails:[],
            today_date:this.todayDate(),
            sd:0,
            isAddModal:false,
            documentlist:[],
            workpermit_row:{
                        documentpath: '',
                        documentid: '',
                        expirydate: '',
                        id: ''
                    },
                today_minimum_date:this.todayDate(),
        }
    },
    methods: {
        getBasics(id="",) {
            var self = this;
            axios.post('getworkpermitdetails',{id:id}).then(function (response) {
                self.workpermitdetails = response.data.workpermitdetails;
                self.documentlist = response.data.documentlist;
                self.workpermit_row.id=id;
                // window.scrollTo(0, 0);
            }).then(() => {
                $(".datatable").DataTable({
                    dom: 'Bfrtip',
                    buttons: ['excel', 'pdf'],
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false
                });
                  
            });


        },
        todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },
  isDocExpire(doc_expiry_date) {
                if(new Date(this.today_date)> new Date(doc_expiry_date))
                    return true;
                else
                    return false;
                },

        deleteitem(id,workpermitid) {
                var self = this;
                Swal.fire({
                    title: 'Are you sure?',
                    text: "Do you really want to delete this?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('deletedocumentsdetails', { id: id ,workpermitid: workpermitid }).then(function (response) {
                        self.workpermitdetails = response.data.workpermitdetails;
                      
                        window.scrollTo(0, 0);
                        Swal.fire(
                            'Deleted!',
                            'The item has been deleted.',
                            'success'
                        );
                    });
                }
            });
        },
        
        //02.06.2025
        showAddModal(){
            this.isAddModal=!this.isAddModal;
            
        },
          handleSelectDoc(selectedvisitor) {
             this.workpermit_row.documentid= selectedvisitor.id;
        },

 onFileChange(workpermit_row) {
                const file = event.target.files[0];
                if (file) {
                    workpermit_row.documentpath = file;
                }
            },

    

        save_document() {
                var self = this;
                if (!self.workpermit_row.documentid) {
                    self.$swal("Select Document Name");
                } else {
                    const formData = new FormData();
                            formData.append(`documentid`, self.workpermit_row.documentid);
                            formData.append(`documentpath`, self.workpermit_row.documentpath);
                            formData.append(`expirydate`, self.workpermit_row.expirydate);
                            formData.append(`id`, self.workpermit_row.id);
     
                    axios.post('saveWpDocument', formData)
                        .then(response => {
                            
                            var msg = response.data.msg;
                            var isSuccess = response.data.status; 
                            self.$swal(msg);
                            if (isSuccess == 1) {
                                if ($.fn.dataTable.isDataTable('.datatable')) {
                                    $('.datatable').DataTable().destroy();
                                }
                                
                                self.workpermitdetails = response.data.workpermitdetails; 
                                self.isAddModal=!self.isAddModal;
                                self.workpermit_row={
                                    documentpath: '',
                                    documentid: '',
                                    expirydate: '',
                                    id: self.workpermit_row.id
                                };
                                
                            }
                        }).then(response=>{
                            $(".datatable").DataTable({
                                    dom: 'Bfrtip',
                                    buttons: ['excel', 'pdf'],
                                    "paging": true,
                                    "ordering": true,
                                    "autoWidth": false
                                }); 
                        }) 
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },

    async downloadFile(path,name) {
      const response = await fetch(path);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = this.$refs.downloadLink;
      link.href = url;
      link.download = name;
      link.click();

      window.URL.revokeObjectURL(url);
    }

     
          
    }
}
</script>

<style>
    td {
  pointer-events: auto;
}
</style>
